import { useAuthContext } from 'contexts/AuthContext';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

type AuthGuardProps = {
  children: ReactNode;
  allowAuthenticated?: boolean;
};

function AuthGuard({ children, allowAuthenticated = false }: AuthGuardProps) {
  const { auth } = useAuthContext();
  if (auth?.token && !allowAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AuthGuard;
